// Componente per la lista delle notifiche

import React from 'react';
import { Notification } from '../../types';
import './NotificationList.css';

interface NotificationListProps {
    notifications: Notification[];
    onDismiss: (id: string) => void;
}

const NotificationList: React.FC<NotificationListProps> = ({ notifications, onDismiss }) => {
    return (
        <div className="notification-list">
            <h2>Notifiche</h2>
            <ul className="notification-list-items">
                {notifications.map((notification) => (
                    <li key={notification.id} className={`notification-item ${notification.type}`}>
                        <div className="notification-content">
                            <h3>{notification.title}</h3>
                            <p>{notification.message}</p>
                            <div className="notification-actions">
                                <button onClick={() => onDismiss(notification.id)}>Chiudi</button>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default NotificationList;
